import type { WikiTopic } from "../types.js";
import { readingTheFeed } from "./reading-the-feed.js";
import { retiredTypes } from "./retired-types.js";

/**
 * The two topics that document the feed rather than a strategy.
 *
 * Retired types first: a reader who arrives here is usually holding a type
 * name no page explains, and the second topic is the one they read next.
 */
export const referenceTopics: readonly WikiTopic[] = [retiredTypes, readingTheFeed];
